var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconAct"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.99967C2 2.62941 3.04951 1.33301 4.5641 1.33301H9.69122C10.2171 1.33301 10.7218 1.54014 11.0961 1.90955L13.4049 4.18826C13.7857 4.56406 14 5.07674 14 5.61171V11.9997C14 13.3699 12.9505 14.6663 11.4359 14.6663H4.5641C3.04951 14.6663 2 13.3699 2 11.9997V3.99967ZM4.66667 9.66663C4.66682 9.85059 4.816 9.99967 5 9.99967H7C7.18409 9.99967 7.33333 9.85044 7.33333 9.66634V8.99968C7.33333 8.81558 7.1841 8.66634 7 8.66634H5C4.816 8.66634 4.66682 8.81543 4.66667 8.99939C4.66667 8.99948 4.66667 8.99958 4.66667 8.99967V9.66634C4.66667 9.66644 4.66667 9.66653 4.66667 9.66663ZM5 7.33301H7H9C9.1841 7.33301 9.33333 7.18377 9.33333 6.99967V6.33301C9.33333 6.14891 9.1841 5.99967 9 5.99967H5C4.816 5.99967 4.66682 6.14876 4.66667 6.33272C4.66667 6.33282 4.66667 6.33291 4.66667 6.33301V6.99967C4.66667 6.99977 4.66667 6.99987 4.66667 6.99996C4.66682 7.18392 4.816 7.33301 5 7.33301ZM3.33333 6.99967V6.33301V3.99967C3.33333 3.2633 3.88437 2.66634 4.5641 2.66634H9.69122C9.86652 2.66634 10.0348 2.73538 10.1595 2.85852L12.4683 5.13723C12.5952 5.2625 12.6667 5.43339 12.6667 5.61171V11.9997C12.6667 12.7361 12.1156 13.333 11.4359 13.333H4.5641C3.88437 13.333 3.33333 12.7361 3.33333 11.9997V9.66634V8.99967V6.99967ZM5 8.99967L5 8.66634L5 8.99967L5 6.33301V6.99967",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDraft);
export default __webpack_public_path__ + "static/media/iconDraft.51aba72306b5b5cc3e0fc88cd9a360a9.svg";
export { ForwardRef as ReactComponent };